import { OutboundCallController } from "@/models/InboundCall/OutboundCallController";
import { OutboundCallControllerAdapter } from "@/models/InboundCall/OutboundCallControllerAdapter";

export const DEFAULT_SNACKBAR_STATE = {
  isActive: false,
  message: "",
  color: "",
  timeout: -1,
};

export const DEFAULT_ACTIVE_CALL_STATE = {
  listOfActiveCalls: [],
  isTransferringCall: false,
  listOfCustomerService: [],
  snackbarState: { ...DEFAULT_SNACKBAR_STATE },
  interruptedCalls: [],
  isLoadingAnswerOrRejectCall: false,
  outboundCalls: {} as Record<string, OutboundCallController>,
  outboundCallLoadingStates: {} as Record<string, boolean>,
  outboundCallAdapters: {} as Record<string, OutboundCallControllerAdapter>,
};

export enum ERROR_REASON {
  CALL_LIMITATION_ERROR = "CALL_LIMITATION_ERROR",
  MIC_DENIED = "MIC_DENIED",
  MIC_NOT_GRANTED = "MIC_NOT_GRANTED",
  SESSION_NOT_RINGING = "SESSION_NOT_RINGING",
  ROLE_NOT_ALLOWED = "ROLE_NOT_ALLOWED",
}
